<template>
  <div class="module">
    <Header v-bind="{ title: title || 'SXSW Scraper Images Module', index, required, active, multiple, count, template }" @remove="$emit('remove', index)" @add="$emit('add', index, defaultModel)" />
    <div v-if="active" class="row">
        <div class="col-5">
          <input v-model="module.limit" type="text" class="form-control">
          <small class="text-muted">Limit (enter 0 for no limit)</small>
        </div>
        <div class="col-2">
          <button type="button" class="btn btn-primary" @click.prevent.stop="getApiData">Test Api</button>
        </div>
    </div>
    <div v-if="active && apiResults" class="row">
      <div class="col">
        <pre class="api-result">{{ apiResults }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import Header from 'rph-slides-vue/src/components/slides/modules/Header.vue'
import { validationMixin } from 'rph-slides-vue/src/mixins/validationMixin.js'
import { moduleMixin } from 'rph-slides-vue/src/mixins/moduleMixin.js'
import { testApiMixin } from 'rph-slides-vue/src/mixins/testApiMixin.js'

export default {
  name: 'SxswScraperEventsImagesModule',
  mixins: [validationMixin, moduleMixin, testApiMixin],
  components: { Header },
  defaultModel: {
    type: 'SxswScraperEventsImagesModule',
    limit: 100
  }
}
</script>
